import gql from 'graphql-tag';

export const degreeEnrollmentChecklistsV1Query = gql`
  query degreeEnrollmentChecklistsV1Query($id: String!) {
    DegreeEnrollmentChecklistsV1Resource {
      get(id: $id) {
        id
        completedItems
      }
    }
  }
`;

export default {
  degreeEnrollmentChecklistsV1Query,
};
